/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';
import { diagnosis } from '../diagnosis';

export class diagnosisreference extends diagnosis {
	diagnosis_reference_key: string = "";
  diagnosis_type_code: string = "";
  encounter_progress_notes_key: string = "";
  contraindication: boolean = false;
  interaction: boolean = false;
  synonym: boolean = false;
  required: boolean = false;
  includes: boolean = false;
  includes_description: string = "";
  excludes1: boolean = false;
  excludes1_description: string = "";
  excludes2: boolean = false;
  excludes2_description: string = "";
  consider: boolean = false;

  gettablename(): string {
    return "DIAGNOSIS_REFERENCE";
  }
}
